import { useWalletDetails } from "@sundae/wallet-react";
import { useQuery } from "@tanstack/react-query";

import { getStats2Sdk } from "../client/statsSdk";

export const useWalletPositions = ({
  pageSize = 50,
  page = 0,
}: {
  pageSize?: number;
  page?: number;
}) => {
  const { details } = useWalletDetails();
  const queryInfo = useQuery(
    ["getWalletPositions", details, pageSize, page],
    async () => {
      const { getPositions } = await getStats2Sdk();
      return getPositions({
        wallet: details?.mainAddress,
        pageSize,
        page,
      });
    },
    {
      enabled: !!details?.mainAddress,
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60,
    }
  );

  return {
    isFetched: queryInfo.isFetched,
    isFetching: queryInfo.isFetching,
    isLoading: queryInfo.isLoading,
    positions: queryInfo?.data?.positions?.liquidity?.liquidity ?? [],
  };
};
